export default __webpack_public_path__ + "icons/errorCircle-555160.svg";